module.exports = __webpack_public_path__ + "img/devices.9b8501ce.svg";